import { render, staticRenderFns } from "./invoice-view.vue?vue&type=template&id=704b7e68&scoped=true&"
import script from "./invoice-view.vue?vue&type=script&lang=js&"
export * from "./invoice-view.vue?vue&type=script&lang=js&"
import style0 from "./invoice-view.vue?vue&type=style&index=0&lang=css&"
import style1 from "./invoice-view.vue?vue&type=style&index=1&id=704b7e68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b7e68",
  null
  
)

export default component.exports